import { render } from "./ConsumptionCreate.vue?vue&type=template&id=5aee8610&scoped=true"
import script from "./ConsumptionCreate.vue?vue&type=script&lang=js"
export * from "./ConsumptionCreate.vue?vue&type=script&lang=js"

import "./ConsumptionCreate.vue?vue&type=style&index=0&id=5aee8610&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aee8610"]])

export default __exports__